import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Custom Cake Design',
        content: 'Bespoke cake design services for birthdays, weddings, and celebrations, crafted to your unique vision and taste.',
        paragraphs: [
            'Celebrate life’s sweetest moments with our custom cake design service. We work closely with you to craft cakes that reflect your theme, style, and flavors, making your celebration truly special.',
            'From handcrafted decorations to premium ingredients, our bakers ensure every cake is both a visual masterpiece and a delicious treat your guests will love.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Personalized Cake Designs',
            'Wide Range of Flavors & Fillings',
            'Custom Themes & Decorations',
            'Gluten-Free & Vegan Options Available',
            'On-time Pickup & Delivery'
        ],
        process: [
            'Discuss Theme & Design Preferences',
            'Select Cake Size, Flavor & Fillings',
            'Finalize Decoration & Delivery Details',
            'Cake Creation & Decoration Process',
            'Pickup or Delivery to Your Location'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of custom cakes do you offer?',
                content: 'We create birthday cakes, wedding cakes, anniversary cakes, baby shower cakes, and more, customized to your theme and preference.'
            },
            {
                id: 2,
                heading: 'How far in advance should I place an order?',
                content: 'For custom cakes, we recommend placing your order at least 3-5 days in advance to ensure availability and preparation time.'
            },
            {
                id: 3,
                heading: 'Can I request a specific flavor combination?',
                content: 'Yes, we offer a variety of flavors and fillings. You can mix and match according to your taste preferences.'
            },
            {
                id: 4,
                heading: 'Do you offer delivery for custom cakes?',
                content: 'Yes, we offer both pickup and delivery options for your convenience. Delivery charges may apply based on your location.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Online Ordering',
        content: 'Convenient and easy online ordering system allowing customers to place bakery orders anytime, anywhere.',
        paragraphs: [
            'Enjoy our delicious baked goods from the comfort of your home. Our online ordering system lets you browse the menu, customize your order, and schedule pickup or delivery at your convenience.',
            'With a user-friendly interface and secure payment options, ordering your favorite cakes, pastries, and treats has never been easier or faster.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Browse Full Bakery Menu',
            'Customize Cakes & Pastries',
            'Secure Online Payments',
            'Real-Time Order Tracking',
            'Pickup & Delivery Options'
        ],
        process: [
            'Browse Menu Online',
            'Add Items to Cart & Customize',
            'Choose Pickup or Delivery',
            'Complete Secure Payment',
            'Receive Confirmation & Delivery/Pickup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How do I place an online order?',
                content: 'Simply browse our website, add your favorite items to the cart, customize as needed, and checkout with your preferred payment method.'
            },
            {
                id: 2,
                heading: 'Can I schedule an order in advance?',
                content: 'Yes, you can select a future date and time during checkout for pickup or delivery.'
            },
            {
                id: 3,
                heading: 'What payment methods are accepted online?',
                content: 'We accept major credit/debit cards, digital wallets, and other secure payment options for online orders.'
            },
            {
                id: 4,
                heading: 'How do I know if my order was received?',
                content: 'You will receive an order confirmation email with details and estimated pickup or delivery time.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Specialty Breads',
        content: 'Artisan-crafted specialty breads baked fresh daily, offering a perfect blend of tradition and taste.',
        paragraphs: [
            'Our bakery takes pride in creating a wide range of specialty breads using premium ingredients and traditional baking methods. From crusty sourdough to soft brioche, every loaf is crafted to perfection.',
            'Enjoy our fresh-baked breads as part of your daily meals, gourmet sandwiches, or simply with butter and jam for a delightful treat.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Fresh Daily Bakes',
            'Variety of Artisan Breads',
            'Organic & Natural Ingredients',
            'Traditional & Modern Recipes',
            'Custom Bread Orders Available'
        ],
        process: [
            'Select Your Bread Type',
            'Place Order Online or In-store',
            'Our Bakers Prepare Fresh Loaves',
            'Bread is Packaged Safely',
            'Pick Up or Get it Delivered'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of specialty breads do you offer?',
                content: 'We offer sourdough, ciabatta, multigrain, rye, focaccia, brioche, and more, baked fresh daily.'
            },
            {
                id: 2,
                heading: 'Are your breads made with natural ingredients?',
                content: 'Yes, we use organic flours, natural starters, and no artificial preservatives in our breads.'
            },
            {
                id: 3,
                heading: 'Can I place a custom bread order?',
                content: 'Absolutely! Contact us in advance to place custom orders for special recipes or large quantities.'
            },
            {
                id: 4,
                heading: 'How should I store your breads for freshness?',
                content: 'Store in a cool, dry place in a paper bag for best results. You can also freeze our breads for later use.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Baking Workshops',
        content: 'Interactive baking workshops for beginners and enthusiasts to master the art of baking delightful treats.',
        paragraphs: [
            'Join our hands-on baking workshops and learn the secrets of crafting perfect cakes, breads, and pastries from our expert bakers. Whether you’re a beginner or a baking enthusiast, we have classes tailored to your skill level.',
            'Enjoy a fun, educational environment where you’ll gain practical skills, tips, and techniques to elevate your baking game at home or professionally.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Beginner & Advanced Levels',
            'Hands-on Baking Experience',
            'Expert Baker Instructors',
            'Small Group Sessions',
            'Take Home Your Creations'
        ],
        process: [
            'Choose Your Workshop Session',
            'Register Online or In-store',
            'Attend the Workshop',
            'Learn & Practice Baking Skills',
            'Take Home Freshly Baked Goods'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Who can join your baking workshops?',
                content: 'Our workshops are open to all baking enthusiasts, from complete beginners to advanced home bakers.'
            },
            {
                id: 2,
                heading: 'What will I learn during a workshop?',
                content: 'You’ll learn baking fundamentals, recipes for cakes, breads, and pastries, as well as decorating and presentation tips.'
            },
            {
                id: 3,
                heading: 'Do I need to bring my own baking tools?',
                content: 'No, we provide all the necessary baking tools and ingredients during the workshop sessions.'
            },
            {
                id: 4,
                heading: 'How do I register for a workshop?',
                content: 'You can register through our website or visit our bakery to sign up for your preferred workshop session.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Catering & Events',
        content: 'Delicious bakery catering services for parties, weddings, and corporate events, creating memorable experiences with our sweet creations.',
        paragraphs: [
            'Make your special occasions truly memorable with our customized catering services. From elegant dessert tables to themed pastry displays, we provide a wide variety of freshly baked treats for weddings, birthdays, and corporate gatherings.',
            'Our team works closely with you to create a personalized menu and presentation style that fits your event theme and guest preferences.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Custom Dessert Tables',
            'Corporate & Private Event Catering',
            'Seasonal & Themed Menus',
            'On-site Setup & Presentation',
            'Freshly Baked & Artfully Decorated Items'
        ],
        process: [
            'Discuss Your Event Details',
            'Customize the Dessert Menu',
            'Confirm Order & Logistics',
            'On-site Setup & Arrangement',
            'Enjoy the Event with Sweet Treats'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of events do you cater?',
                content: 'We cater to weddings, birthdays, baby showers, corporate gatherings, holiday parties, and more.'
            },
            {
                id: 2,
                heading: 'Can I customize the dessert menu for my event?',
                content: 'Absolutely! We work with you to create a dessert selection that fits your event theme, dietary needs, and guest preferences.'
            },
            {
                id: 3,
                heading: 'Do you provide on-site setup?',
                content: 'Yes, our catering service includes on-site setup for dessert tables and displays to ensure a beautiful presentation.'
            },
            {
                id: 4,
                heading: 'How far in advance should I book catering?',
                content: 'We recommend booking at least 2–4 weeks in advance, especially during peak seasons, to ensure availability and planning time.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Gift Hampers',
        content: 'Thoughtfully curated gift hampers filled with delightful baked goods, perfect for special occasions and corporate gifting.',
        paragraphs: [
            'Share the joy of our bakery with beautifully arranged gift hampers. Each hamper includes a mix of our best-selling treats like cookies, brownies, cupcakes, and specialty breads, wrapped and packaged with care.',
            'Perfect for birthdays, holidays, anniversaries, or corporate gifting, our hampers can be customized with personalized messages and themed packaging.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Customizable Hamper Contents',
            'Beautiful Packaging & Wrapping',
            'Personalized Gift Notes',
            'Corporate & Bulk Orders Available',
            'Seasonal & Festive Themes'
        ],
        process: [
            'Select Hamper Size & Theme',
            'Choose Your Favorite Treats',
            'Add Personal Messages or Branding',
            'Secure Packaging & Wrapping',
            'Delivery to Recipient or Pickup from Bakery'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I customize what goes in the hamper?',
                content: 'Yes, you can choose from a variety of bakery treats and add personal touches like a custom message or themed packaging.'
            },
            {
                id: 2,
                heading: 'Do you offer corporate gifting options?',
                content: 'Absolutely! We provide bulk ordering and branding options for corporate gifting, making it easy to thank your clients or employees.'
            },
            {
                id: 3,
                heading: 'Can I schedule a delivery for a special date?',
                content: 'Yes, you can choose your preferred delivery date during checkout to make sure your gift arrives right on time.'
            },
            {
                id: 4,
                heading: 'Are the hampers available for festive seasons?',
                content: 'Yes, we offer special themed hampers for occasions like Christmas, Eid, Valentine’s Day, and other festive celebrations.'
            }
        ]
    }

];

export default services;